import { FC, useCallback } from 'react';
import { useField, useForm } from 'react-final-form';

import { ProgressButton } from '@beeline/design-system-react/extracted-styles';

import { Panel } from 'src/components/Panel/Panel';
import { removeTown } from 'src/store/towns/services';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { AdministratorTownFields } from '../AdministratorTownForm/AdministratorTownFields';
import { AdministratorTownForm } from '../AdministratorTownForm/AdministratorTownForm';

const Actions: FC = () => {
  const id = useField<number | undefined>('id').input.value;
  const dispatch = useAppDispatch();

  const { submit } = useForm();

  const saveTown = useCallback(async () => {
    const result = await submit();
    if (!result) throw new Error('Form is invalid');
  }, [submit]);

  const deleteTown = useCallback(async () => {
    if (id) await dispatch(removeTown(id));
  }, [dispatch, id]);

  return (
    <>
      {id && (
        <ProgressButton
          variant='outlined'
          onClick={deleteTown}
          data-testid='deleteTown'
        >
          Удалить
        </ProgressButton>
      )}
      <ProgressButton
        variant='contained'
        onClick={saveTown}
        data-testid='saveTown'
        type='submit'
      >
        {id ? 'Сохранить' : 'Создать'}
      </ProgressButton>
    </>
  );
};

export const AdministratorTownSidesheetPanel: FC = () => {
  return (
    <AdministratorTownForm>
      <Panel actions={<Actions />} testId='administratorTownSidesheetPanel'>
        <AdministratorTownFields />
      </Panel>
    </AdministratorTownForm>
  );
};
